import Axios from 'axios';
import ApiUtils from './api-utils';

export default {
  getAllContratsByTiers: (param) => ApiUtils.responseParser(Axios.get(`/web/v1/tiers/${param.numTiers}/contrats?typeTiers=${param.typeTiers}&numEntite=${param.numEntite}&dateValidite=${param.dateValidite}`))
};
